import { SVGFC } from '@repo/toolkit/types'

const XIcon: SVGFC = ({ color, ...props }) => {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.24359 2.24335C2.34614 2.14092 2.48516 2.08339 2.63009 2.08339C2.77503 2.08339 2.91405 2.14092 3.0166 2.24335L5.00016 4.22618L6.98373 2.24335C7.03448 2.19259 7.09474 2.15233 7.16106 2.12486C7.22737 2.09739 7.29845 2.08325 7.37023 2.08325C7.44201 2.08325 7.51309 2.09739 7.5794 2.12486C7.64572 2.15233 7.70598 2.19259 7.75673 2.24335C7.80749 2.2941 7.84775 2.35436 7.87522 2.42068C7.90269 2.48699 7.91683 2.55807 7.91683 2.62985C7.91683 2.70163 7.90269 2.77271 7.87522 2.83902C7.84775 2.90534 7.80749 2.9656 7.75673 3.01635L5.7739 4.99992L7.75673 6.98348C7.85924 7.08599 7.91683 7.22502 7.91683 7.36999C7.91683 7.51495 7.85924 7.65398 7.75673 7.75649C7.65423 7.859 7.5152 7.91658 7.37023 7.91658C7.22526 7.91658 7.08623 7.859 6.98373 7.75649L5.00016 5.77365L3.0166 7.75649C2.91409 7.859 2.77506 7.91658 2.63009 7.91658C2.48513 7.91658 2.3461 7.859 2.24359 7.75649C2.14108 7.65398 2.0835 7.51495 2.0835 7.36999C2.0835 7.22502 2.14108 7.08599 2.24359 6.98348L4.22643 4.99992L2.24359 3.01635C2.14117 2.9138 2.08364 2.77479 2.08364 2.62985C2.08364 2.48491 2.14117 2.3459 2.24359 2.24335Z"
        fill={color}
      />
    </svg>
  )
}

export default XIcon
